import type { Gallery } from '@typings/reviews';
import { atom } from 'jotai';
import { unstable_batchedUpdates } from 'react-dom';
import type { GoogleReviewsResponseData } from 'types/api/reviews';
import {
	fetchReviewsAtom,
	isViewMoreAtom,
	reviewsLoadableStatesAtom,
	searchSortFilterAtom,
	searchSortFilterReducer,
} from './components/search-sort-filter/atoms';
import { amountToRenderAtom, reviewsCollectionAtom } from './shared-atoms';

const DEFAULT_AMOUNT_TO_RENDER = 5;
const INCREMENT_BY = DEFAULT_AMOUNT_TO_RENDER;

export interface ReviewStarBuckets {
	stars1: number;
	stars2: number;
	stars3: number;
	stars4: number;
	stars5: number;
}

export const totalCountAtom = atom<number>(0);
export const gallerySizeAtom = atom<number>(0);
export const reviewsWithPhotosCountAtom = atom<number>(0);
export const ratingAtom = atom<number>(0);
export const reviewStarBucketsAtom = atom<ReviewStarBuckets>({
	stars1: 0,
	stars2: 0,
	stars3: 0,
	stars4: 0,
	stars5: 0,
});
export const galleryAtom = atom<Gallery[]>([]);
export const hasCurrentUserReviewedAtom = atom<boolean>(false);
export const isFetchingAtom = atom<boolean>((get) => {
	const reviewsLoadable = get(reviewsLoadableStatesAtom);
	const isViewMore = get(isViewMoreAtom);

	if (reviewsLoadable.state === 'loading') {
		return !isViewMore;
	}

	return false;
});
export const isFetchingMoreAtom = atom<boolean>((get) => {
	const reviewsLoadable = get(reviewsLoadableStatesAtom);
	const isViewMore = get(isViewMoreAtom);

	if (reviewsLoadable.state === 'loading') {
		return isViewMore;
	}

	return false;
});
export const googleReviewsAtom = atom<GoogleReviewsResponseData>({
	rating: 0,
	totalReviewCount: 0,
	totalReviewCountFormatted: null,
	externalUrl: '',
	reviews: [],
});

export const viewMoreFetchAtom = atom(null, (get, set) => {
	const reviewsCollection = get(reviewsCollectionAtom);
	const amountToRender = get(amountToRenderAtom);
	if (reviewsCollection.length > amountToRender) {
		set(amountToRenderAtom, amountToRender + INCREMENT_BY);
	} else {
		unstable_batchedUpdates(() => {
			set(searchSortFilterAtom, (prev) =>
				searchSortFilterReducer(prev, { type: 'fetch-more' }),
			);
			set(amountToRenderAtom, amountToRender + INCREMENT_BY);
		});
		set(fetchReviewsAtom);
	}
});
